import type { AssetTreeNode } from "@/entities/asset-tree";

export const isAssetTreeNodeSector = ({ type, parent_type }: AssetTreeNode) => {
  return type === "location" && parent_type === "location";
};
